// extracted by mini-css-extract-plugin
export default {"formHeading":"ContactForm_formHeading__4Hsls","formControl":"ContactForm_formControl__kMPfh","btnDiv":"ContactForm_btnDiv__gUc71","primaryBtn":"ContactForm_primaryBtn__CWbwi"};